import React from 'react';
import { FlowerIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-tinta py-12 text-crema/80" data-id="element-33" data-mp="3gfsmscqd8umz">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-34" data-mp="3ghc2o28413o8">
        <div className="flex flex-col items-center gap-6 text-center sm:flex-row sm:justify-between sm:text-left" data-id="element-35" data-mp="32ovw4rg02nik">
          <div className="flex items-center gap-2.5" data-id="element-36" data-mp="36q94b86kf2sn">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-rosa/25" data-id="element-37" data-mp="3ufa4k858v7mu">
              <FlowerIcon className="h-5 w-5 text-rosa-light" strokeWidth={1.6} data-id="element-38" data-mp="38h4x8q3ngkf" />
            </span>
            <span className="leading-tight" data-id="element-39" data-mp="3ldkgncakmqtt">
              <span className="block font-serif text-lg font-semibold text-crema" data-id="element-40" data-mp="3qdf2h1fhoq80">
                Cambio Hormonal
              </span>
              <span className="block text-xs uppercase tracking-[0.2em] text-dorado-light" data-id="element-41" data-mp="29y5gy0qz9kv0">
                El Método del 1%
              </span>
            </span>
          </div>

          <a href="mailto:hola@metododel1.com" className="inline-flex items-center gap-2 text-sm text-crema/80 transition-colors hover:text-crema focus:outline-none focus-visible:ring-2 focus-visible:ring-rosa/40 rounded" data-id="element-42" data-mp="3l90l3octskvk">
            <MailIcon className="h-4 w-4" strokeWidth={1.8} data-id="element-43" data-mp="3v5n4s9tf15w0" />
            hola@metododel1.com
          </a>
        </div>

        <p className="mt-8 max-w-3xl text-xs leading-relaxed text-crema/55" data-id="element-44" data-mp="830hxf7jlyyw">
          Este programa tiene fines informativos y de bienestar. No sustituye el
          consejo, diagnóstico ni tratamiento médico profesional. Consulta
          siempre con tu médico o especialista ante cualquier duda sobre tu
          salud.
        </p>

        <p className="mt-6 text-xs text-crema/50" data-id="element-45" data-mp="cus29803v8gl">
          © {new Date().getFullYear()} Cambio Hormonal · El Método del 1%.
          Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}